module.exports = __webpack_public_path__ + "media/04. M.O.O.N. - Crystals.01e6d167.mp3";